import React, { useState } from "react";
import Navbar from "../components/landing/Navbar";
import Hero from "../components/landing/Hero";
import Footer from "../components/landing/Footer";
import OurStory from "./OurStory";
import Founders from "./Founders";
import Contact from "./Contact";
import Pricing from "../components/landing/Pricing";

export default function LandingPage() {
  const [active, setActive] = useState("home");

  return (
    <div style={{ fontFamily: "'Segoe UI', sans-serif", minHeight: "100vh", background: "#080d20" }}>
      <Navbar active={active} setActive={setActive} />
      {active === "home" && <Hero setActive={setActive} />}
      {active === "Our Story" && <OurStory />}
      {active === "Founders" && <Founders />}
      {active === "Contact" && <Contact />}
      {active === "pricing" && <Pricing />}
      <Footer setActive={setActive} />
    </div>
  );
}
